import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  Grid,
} from "@mui/material";
import { ChargeLine } from "./types";

interface EmergencyServiceProps {
  emergencyServices: boolean;
  onChange: (field: keyof ChargeLine, value: boolean) => void;
  claimStatus: string;
}

const EmergencyService: React.FC<EmergencyServiceProps> = ({
  emergencyServices,
  onChange,
  claimStatus,
}) => {
  return (
    <Grid container spacing={2} alignItems="center" sx={{ minHeight: "160px" }}>
      <Grid item xs={6.5}>
        <Box>
          <Typography
            sx={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "26px",
              fontWeight: 700,
            }}
          >
            Key Details
          </Typography>
          <p
            style={{
              color: "#707070",
              fontSize: "10px",
              lineHeight: "14px",
              fontWeight: 400,
              marginBlockStart: "0px",
              marginBlockEnd: "0px",
            }}
          >
            Check with the payer to determine if this information is necessary.
            Indicating “Yes” <b>is uncommon.</b>
          </p>
        </Box>
      </Grid>

      <Grid item xs={5.5}>
        <FormControl>
          <FormLabel
            style={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            Emergency Service?
          </FormLabel>
          <RadioGroup
            row
            value={emergencyServices ? "yes" : "no"}
            onChange={(e) =>
              onChange("emergency_services", e.target.value === "yes")
            }
            sx={{ display: "flex", columnGap: "10px" }}
          >
            <FormControlLabel
              value="no"
              disabled={
                claimStatus === "submitted" ||
                claimStatus === "pending_submission"
              }
              control={
                <Radio
                  sx={{
                    p: 0,
                    "& .MuiSvgIcon-root": {
                      fontSize: 16,
                      marginRight: "5px",
                    },
                  }}
                />
              }
              label="No"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#1E1E1E",
                },
                marginLeft: "0px",
              }}
            />
            <FormControlLabel
              value="yes"
              disabled={
                claimStatus === "submitted" ||
                claimStatus === "pending_submission"
              }
              control={
                <Radio
                  sx={{
                    p: 0,
                    "& .MuiSvgIcon-root": {
                      fontSize: 16,
                      marginRight: "5px",
                    },
                  }}
                />
              }
              label="Yes"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#1E1E1E",
                },
              }}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default EmergencyService;
